import { CenterSpin } from '@/components/CenterSpin';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAccessibleTeams } from '../contexts/AccessibleTeamsContext';

const SELECTED_TEAM_KEY = 'platform-selected-team';

export const RootRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { teams, defaultTeam, isLoading } = useAccessibleTeams();

  useEffect(() => {
    if (!isLoading) {
      // Check localStorage for previously selected team
      const savedTeamId = localStorage.getItem(SELECTED_TEAM_KEY);
      const savedTeamIsAccessible =
        savedTeamId && teams.some((team) => team.teamId === savedTeamId);

      if (savedTeamIsAccessible) {
        // Redirect to previously selected team
        void navigate(`/team/${savedTeamId}`, { replace: true });
      } else if (defaultTeam) {
        // Redirect to default team
        void navigate(`/team/${defaultTeam.teamId}`, { replace: true });
      } else if (teams.length > 0) {
        // Redirect to first available team
        void navigate(`/team/${teams[0].teamId}`, { replace: true });
      } else {
        // No teams available - redirect to a no-teams page
        void navigate('/no-teams', { replace: true });
      }
    }
  }, [teams, defaultTeam, isLoading, navigate]);

  return <CenterSpin />;
};

export default RootRedirect;
